const ACTION_REGISTER = 'register';
const ACTION_LOGIN = 'login';

export { ACTION_LOGIN, ACTION_REGISTER };

export default {
    ACTION_LOGIN,
    ACTION_REGISTER
};



// WEBPACK FOOTER //
// ./src/components/AccountNav/accountConstants.js